export const consentType = {
  EMAIL: 'email',
  SIGNATURE: 'signature',
};

export const guardianSelectTypes = {
  HOUSEHOLD_MEMBER: 'household_member',
  OTHER_PERSON: 'other_person',
};
